import {
    type FC,
    Suspense,
    lazy
} from 'react';

import type {
    CategoryIconProps
} from './types';

const load = (icon: string) => import(
    /* webpackMode: "lazy" */
    /* webpackChunkName: "icon-[request]" */
    /* webpackInclude: /\.svg$/ */
    `../../../assets/icons/supporters/${icon}`
);

const CategoryIcon: FC<CategoryIconProps> = ({
    icon, ...svgProps
}) => {
    // Guard before creating the lazy component
    if (!icon) {
        if (process.env.PUBLISH_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn('CategoryIcon: `icon` prop is missing or undefined.');
        }

        return null;
    }

    // Create the lazy component only when we actually have a valid icon string
    const LazyIcon = lazy(() => load(icon));

    return (
        <Suspense fallback={null}>
            <LazyIcon
                role={'img'}
                {...svgProps}
            />
        </Suspense>
    );
};

export default CategoryIcon;
